import React, { Component } from 'react'
import { Link } from 'react-router'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import Banner from './Banner'
import BuyForm from './BuyForm'
import ProtocolModal from './ProtocolModal'
import ConfirmModal from './ConfirmModal'
import { observer } from 'mobx-react'
import { LIVE_MANAGE_PATH } from '@constant'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.store.getBuyInfo()
  }
  render() {
    const header = [<Link to={LIVE_MANAGE_PATH}>视频直播</Link>, '购买直播']

    return (
      <HeaderView
        header={header}
        title="购买直播"
        contentStyle={{ padding: '40px 20px 40px 40px' }}
      >
        <Banner store={this.store} />
        <BuyForm store={this.store} />
        <ProtocolModal store={this.store} />
        <ConfirmModal store={this.store} />
      </HeaderView>
    )
  }
}
